import {
  MdSignalCellular1Bar,
  MdPhoto,
  MdCastForEducation,
  MdPriorityHigh,
  MdHome,
  MdSupervisedUserCircle,
  MdEditCalendar,
  MdPeople,
  MdCardMembership,
  MdStar,
  MdImage,
  MdDashboard,
  MdViewCarousel,
  MdFolder,
  MdCategory,
  MdAnnouncement,
  MdReceipt,
  MdScience,
  MdForwardToInbox,
  MdApps,
  MdVideoLibrary,
  MdRocketLaunch,
  MdLocalOffer,
} from "react-icons/md";

export const menu = [
  {
    id: "0",
    route: "/home",
    title: "Dashboard",
    icon: <MdDashboard />,
  },
  {
    id: "2",
    route: "/services",
    title: "Videos",
    icon: <MdCastForEducation />,
  },
];
export const menuAcademy = [
  {
    id: "academia",
    route: "/academia",
    title: "Academia",
    icon: <MdApps />,
  },
  {
    id: "contenido",
    route: "/contenido",
    title: "Contenido",
    icon: <MdVideoLibrary />,
  },
];

export const menuSignals = [
  {
    id: "8",
    route: "/signals",
    title: "Señales",
    icon: <MdSignalCellular1Bar />,
    adminOnly: true,
  },
];
export const menuSchedules = [
  {
    id: "6",
    route: "/schedules/masterclass",
    title: "Masterclass",
    icon: <MdEditCalendar />,
  },
  {
    id: "6",
    route: "/schedules/sessions",
    title: "Sessions",
    icon: <MdEditCalendar />,
  },
];
export const menuUsers = [
  {
    id: "7",
    route: "/users",
    title: "Control de Usuarios",
    icon: <MdSupervisedUserCircle />,
    adminOnly: true,
  },
  {
    id: "10",
    route: "/orders",
    title: "Órdenes",
    icon: <MdReceipt />,
    adminOnly: true,
  },
  {
    id: "11",
    route: "/trials",
    title: "Períodos de Prueba",
    icon: <MdScience />,
    adminOnly: true,
  },
  {
    id: "9",
    route: "/plans",
    title: "Planes",
    icon: <MdCardMembership />,
    adminOnly: true,
  },
  {
    id: "8",
    route: "/admins",
    title: "Control de Administradores",
    icon: <MdSupervisedUserCircle />,
    adminOnly: true,
  },
];
export const menuHome = [
  {
    id: "h1",
    route: "/reviews",
    title: "Reseñas",
    icon: <MdStar />,
  },
  {
    id: "h2",
    route: "/home-config",
    title: "Banners Inicio",
    icon: <MdImage />,
  },
  {
    id: "h5",
    route: "/primeros-pasos",
    title: "Primeros Pasos",
    icon: <MdRocketLaunch />,
  },
  {
    id: "h6",
    route: "/top-servicios",
    title: "Top Servicios",
    icon: <MdLocalOffer />,
  },
  {
    id: "h3",
    route: "/resumen-config",
    title: "Tarjetas Resumen",
    icon: <MdViewCarousel />,
  },
  {
    id: "h4",
    route: "/resources",
    title: "Recursos",
    icon: <MdFolder />,
  },
];

export const menuIB = [
  {
    id: "ib2",
    route: "/commissions",
    title: "Comisiones",
    icon: <MdCardMembership />,
    adminOnly: true,
  },
];

export const menuNotifications = [
  {
    id: "5",
    title: "Notificaciones",
    icon: <MdPriorityHigh />,
    submenu: [
      {
        route: "/notifications",
        title: " Push",
        icon: <MdPriorityHigh />,
      },
      {
        route: "/weekly-notifications",
        title: "Semanales",
        icon: <MdPriorityHigh />,
      },
      {
        route: "/telegram",
        title: "Canal Telegram",
        icon: <MdForwardToInbox />,
      },
    ],
  },
];
